import Button from "./Button";
import styles from "./Hero.module.css";

export default function Hero({ image, title, subtitle, cta }) {
  return (
    <section className={styles.hero}>
      <img className={styles.image} src={image} alt="Hero" />
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
        <p className={styles.kicker}>Prepared. Capable. Always ready.</p>
        <Button label={cta} size="lg" />
      </div>
    </section>
  );
}
